<template>
  <div class="p-2 pb-6 rounded-lg shadow-sm hover:shadow-lg bg-white cursor-pointer relative content-item-container" @click="onClick">
    <div v-if="!!content" class="max-h-80 overflow-hidden content-item">
      <p class="text-right text-xs text-slate-500 absolute right-0 bottom-0 italic mx-2 my-1">{{ time }}</p>
      <div v-if="adminMode" class="right-0 top-0 copy-button invisible absolute m-2">
        <div  class="bg-red-500 py-1 px-2 m-1 rounded-full text-sm  text-center shadow">
          <span v-if="deleting" class="text-white font-bold">Deleting ...</span>
          <span v-else class="text-white">Click to delete</span>
        </div>
      </div>
      <div v-else class="right-0 top-0 copy-button invisible absolute m-5">
        <div class="bg-primary py-1 px-2 m-1 rounded-full text-sm w-24 text-center shadow">
          <span v-if="copied" class="text-white font-bold">Copied</span>
          <span v-else class="text-white">Click to copy</span>
        </div>
      </div>
      <p v-if="isImage"><img :src="s3imageUrl" ref="image" alt="" v-show="imageLoaded" @load="imageLoaded = true"/></p>
      <p v-else>{{ content.data }}</p>
    </div>
    <div v-else class="text-gray-300">
      Loading ...
    </div>
  </div>
</template>

<script>
import TimeAgo from "javascript-time-ago";

export default {
  props: {
    'contentId': {
      type: Number,
      required: true,
    },
    'contentData': {
      type: Object,
      default: null,
    },
    'adminMode': {
      type: Boolean,
      default: false,
    }
  },
  async mounted() {
    if(this.content) {
      this.generateDisplayTime();
      this.startPeriodicRefresh();
    } else {
      this.getContent(this.contentId).then(() => {
        this.startPeriodicRefresh();
      });
    }
  },
  beforeUnmount() {
    this.stopPeriodicRefresh();
  },
  data() {
    return {
      content: this.contentData,
      copied: false,
      deleting: false,
      time: "",
      refreshIntervalHandler: null,
      imageLoaded: false,
    }
  },
  computed: {
    isImage() {
      return this.content.type === 'image';
    },
    s3imageUrl() {
      if(!this.isImage) {
        // Transparent 1 pixel image
        return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=';
      }

      return `https://s3-ap-southeast-1.amazonaws.com/${process.env.MIX_AWS_BUCKET}/${this.content.data}`
    }
  },
  methods: {
    async getContent(id) {
      let response = await axios.get(`/content/${id}`);
      let content = response.data;
      this.content = content;

      this.generateDisplayTime();
    },
    async deleteContent(id) {
      this.deleting = true;
      let response = await axios.post(`/content/${id}/delete`);
    },
    onClick() {
      if(this.adminMode) {
        if(!confirm("Are you sure you want to delete this content?")) {
          return;
        }
        this.deleteContent(this.contentId);
      } else {
        this.copyToClipboard();
      }
    },
    async copyToClipboard() {
      try {
        if (this.isImage) {
          var s = window.getSelection()
          var r = document.createRange();
          r.selectNode(this.$refs.image);
          s.removeAllRanges();
          s.addRange(r);
          document.execCommand("copy");
          s.removeAllRanges();

        } else {
          await navigator.clipboard.writeText(this.content.data)
        }
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1000);
      } catch (e) {
        console.error(e);
        alert('Failed to copy')
      }
    },
    generateDisplayTime() {
      const timeAgo = new TimeAgo('en-MY');
      const date = new Date(this.content.created_at);
      this.time = timeAgo.format(date, undefined, {now: Math.max(Date.now(), Number(date))});
    },
    startPeriodicRefresh() {
      this.refreshIntervalHandler = setInterval(() => {
       this.generateDisplayTime();
      }, 60000);
    },
    stopPeriodicRefresh() {
      if(this.refreshIntervalHandler) {
        clearInterval(this.refreshIntervalHandler);
        this.refreshIntervalHandler = null;
      }
    },
  },
};
</script>
